import { createListenerMiddleware } from '@reduxjs/toolkit';

import { Toaster } from '~components/Toaster';
import { dialogsApi } from '~services/api/dialogs';

export const messageThrottlingNotificator = createListenerMiddleware();

messageThrottlingNotificator.startListening({
	matcher: dialogsApi.endpoints.sendMessage.matchRejected,
	effect: (action) => {
		if (action.payload?.status === 429) {
			Toaster.showSuccess({
				title: 'You’ve been so hot, please give us a rest...',
				toastId: 'messages_spam',
			});
		}
	},
});
